import styled from 'styled-components';
import close from '../../assets/close.svg';
import { Link } from 'react-router-dom';

interface ContainerProps {
  r: number;
  g: number;
  b: number;
  color: string;
}
export const CustomLink = styled(Link)`
  text-decoration: none;
  font-size: 1.3em;
`;
export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.3% 2%;
  min-width: 712px;
  width: 100%;
  border-radius: 0px 0px 16px 0px;
  height: 112px;
  color: rgba(42, 42, 42, 1);
  margin-left: -30px;
  background: rgba(
    ${(props) => props.r},
    ${(props) => props.g},
    ${(props) => props.b},
    1
  );
  a:visited {
    color: rgba(1, 128, 199, 1);
  }
  * {
    display: flex;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  }

  .event-name {
    text-align: center;

    /* Heading/H3 */
    font-family: Montserrat, sans-serif;
    font-size: 28px;
    font-style: normal;
    // font-weight: 600;
    line-height: 38.4px; /* 120% */
    color: rgb(107, 121, 151);
  }

  .close-logout {
    color: rgba(1, 128, 199, 1) !important;
    font-family: Montserrat, sans-serif;
    font-size: 20px;
    line-height: 30px;
    font-style: normal;
    font-weight: 500;
    text-align: center;
  }
  .close-text {
    font-size: 20px;
  }
  .close-logout .close-icon {
    width: 30px;
    height: 30px;
    background: url(${close});
  }
  .close-logout .edit-icon {
    color: #0180c7;
    width: 35px;
    height: 35px;
  }
  .close-logout .edit-button {
    color: rgba(1, 128, 199, 1) !important;
    background-color: transparent;
    border: 3px solid #0180c7;
    border-radius: 10px;
    text-decoration: none;
    padding: 5px;
    margin: 0 10px;
  }

  .left-arrow {
    width: 24px;
    height: 24px;
  }

  .left-person {
    color: #ff6384;
    width: 24px;
    height: 24px;
  }
  .right-person {
    color: #36a2eb;
    width: 24px;
    height: 24px;
  }
  .edit-text {
    font-size: 20px;
  }
`;

export const ModalTitle = styled.div`
  display: flex;
  justify-content: space-around;
  .title {
    padding: 0 0 12px 0;
    border-bottom: 2px solid rgba(42, 42, 42, 0.1);
    width: 80%;
    h2 {
      text-align: center;

      /* Heading/H3 */
      font-family: Montserrat, sans-serif;
      font-style: normal;
      // font-weight: 600;
      line-height: 38.4px; /* 120% */
      color: rgb(107, 121, 151);
    }
  }
`;

export const ModalContent = styled.div`
  .update-time {
    background-color: white;
    border: 1px solid #8395ba;
    font-weight: 500;
    border-radius: 4.8px;
    padding: 8px 16px;
    width: 100%;
    color: #6f7b94;
    display: flex;
    align-items: center;

    .update-time-input {
      width: 40%;
      height: 88px;

      flex: 1;
      // background: black;
      border: 0;
      color: #2a2a2a;

      &::placeholder {
        color: #6f7b94;
      }
    }
  }
`;
